<template lang="pug">
SspLayout.order-page(area="core")
  template(slot="actions")
    router-link.btn.btn-default(:to="{ name: 'orderEdit', params: { id: orderId } }")
      i.fa.fa-edit
      span.ml5 Edit
    button.btn.btn-default(@click="showPermissionsDialog")
      i.fa.fa-users
      span.ml5 Permissions
    router-link.btn.btn-default(:to="{ name: 'orderMetadata', params: { id: orderId } }")
      i.fa.fa-code
      span.ml5 Metadata
    button.btn.btn-default(@click="$refs.recallOrderModal.open()")
      i.fa.fa-repeat
      span.ml5 Recall
    router-link.btn.btn-default(:to="{ name: 'geofenceOrder', params: { id: orderId } }")
      i.fa.fa-globe
      span.ml5 Geofence

  .row(v-if="order")
    .col-sm-8
      OrderDetails(:order="order" :recall="recall" :recallError="recallError" :loading="loading")
    .col-sm-4
      .panel.panel-default
        .panel-heading
          .panel-title Go To
        .panel-body(v-if="order")
          .vertical-stacked-buttons
            router-link.btn.btn-default(:to="{ name: 'rolls', params: { orderId: orderId } }")
              i.fa.fa-film
              span.ml5 Rolls
            router-link.btn.btn-default(:to="{ name: 'expansions' }")
              i.fa.fa-qrcode
              span.ml5 Codes
            router-link.btn.btn-default(:to="{ name: 'sections', params: { id: orderId } }")
              i.fa.fa-kz-section
              span.ml5 Sections
            router-link.btn.btn-default(:to="{ name: 'codeStatusStatistics' }")
              i.fa.fa-tag
              span.ml5 Code Status Statistics

  .row
    .col-sm-8
      .panel.panel-default
        .panel-heading
          .panel-title Code Validations
        .panel-body
          .container-fluid
            .row(v-if="orderValidations !== null")
              label.col-sm-4.control-label Total Codes Validated
              .col-sm-2
                span(v-if="orderValidations") {{ orderValidations }}
                em.text-muted(v-else) No validations

              label.col-sm-4.control-label Percentage Of Codes Validated
              .col-sm-2
                span {{percentageCodeValidation}}
            .row(v-else)
              em.text-muted {{ orderValidationsError }}

  Permissions(ref="permissions")
  RecallOrderModal(ref="recallOrderModal" :orderId="orderId" @success="init")
</template>

<script>
import Core from '@/service/apis/Core'
import Permissions from '@/components/ssp/Permissions'
import OrderDetails from './OrderDetails'
import RecallOrderModal from './RecallOrderModal'

export default {
  data: () => ({
    order: null,
    orderValidations: null,
    recall: null,
    loading: false,
    recallError: null,
    orderValidationsError: null
  }),
  created() {
    this.init()
  },
  methods: {
    init() {
      this.loading = true
      Core.getOrder(this.orderId)
        .then((resp) => {
          this.order = resp.data
        })
        .then(() => {
          Core.getRecallsInOrder(this.order.id)
            .then((resp) => {
              this.recall = resp.data.map((r) => ({ name: r }))
            })
            .catch((e) => {
              this.recallError = e.response.data.message
            })
        })
        .catch((e) => {
          this.$emit('error', e)
        })
        .then(() => {
          this.loading = false
        })

      Core.getOrderValidations(this.orderId)
        .then((resp) => {
          this.orderValidations = resp.data.total
        })
        .catch((e) => {
          this.orderValidationsError = e.response.data.message
        })
    },
    showPermissionsDialog() {
      this.$refs.permissions.open('ORDER', this.orderId)
    },
  },
  watch: {
    orderId() {
      this.init()
    }
  },
  computed: {
    percentageCodeValidation() {
      if (this.orderValidations && this.order && this.order.size) {
        return `${100 * (this.orderValidations / this.order.size).toFixed(2)} %`
      }
      return '0 %'
    },
    orderId() {
      return parseInt(this.$route.params.id, 10)
    }
  },
  components: {
    OrderDetails,
    Permissions,
    RecallOrderModal
  }
}
</script>

<style lang="scss">
.order-page {
  .vertical-stacked-buttons {
    padding: 10px;
  }

  .vertical-stacked-buttons .btn {
    margin: 5px 0px;
    display: block;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/core/order/Order.vue